import type { ConfigType } from '@plone/registry';
import { createThemeDefinition } from '@simplesconsultoria/volto-light-theme/config/blocks';

const customThemes = [
  createThemeDefinition('default', 'Default'),
  createThemeDefinition('grey', 'Lavanda'),
  createThemeDefinition('purple', 'Roxo'),
  createThemeDefinition('green', 'Ciano'),
  createThemeDefinition('ink', 'Inky'),
  createThemeDefinition('soft', 'Roxo Suave'),
];

function installThemes(config: ConfigType) {
  config.blocks.themes = customThemes;
  return config;
}

function installGridBlock(config: ConfigType) {
  // Ensure gridBlock uses our custom themes.
  if ((config.blocks.blocksConfig as any).gridBlock) {
    (config.blocks.blocksConfig as any).gridBlock.themes = customThemes;
    (config.blocks.blocksConfig as any).gridBlock.blocksConfig = {
      ...(config.blocks.blocksConfig as any).gridBlock.blocksConfig,
      themes: customThemes,
    };
  }
  return config;
}

export default function install(config: ConfigType) {
  installThemes(config);
  installGridBlock(config);

  return config;
}
